import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Icon, Button, Input, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import GenerateSkeletonComponent from './GenerateSkeletonComponent';
import ModalContentHolder from '../styles/ModalContentStyle';

const InfoRow = ({ icon, label, children }) => (
  <div className="infoCol">
    <Icon className="infoIcon" type={icon} />
    <div className="infoText">
      <div className="label">{label}</div>
      {children}
    </div>
  </div>
);

// `onChangeName` enables the edit button on the name; without it the modal stays read-only.
const ModalContentComponent = ({
  visible = false,
  onCancel,
  content,
  onChangeName,
  disabled = false
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [editingName, setEditingName] = useState(false);

  useEffect(() => {
    if (visible) return;

    setLoading(true);
    setEditingName(false);
  }, [visible]);

  return (
    <>
      {visible && (
        <Modal
          title={t('Content data')}
          visible={visible}
          onCancel={onCancel}
          footer={[
            <Button key="ok" type="primary" onClick={onCancel}>
              {t('Accept')}
            </Button>
          ]}
          width={800}
        >
          <ModalContentHolder>
            {content && (
              <Row type="flex" justify="center">
                <Col xs={14} sm={14}>
                  <div className="contentCardContent" hidden={loading}>
                    {content.file.endsWith('.jpg') ||
                    content.file.endsWith('.png') ||
                    content.file.endsWith('.gif') ? (
                      <img
                        className="appear-animation-without-movement"
                        src={content.file}
                        alt=""
                        width={350}
                        onLoad={() => setLoading(false)}
                      />
                    ) : (
                      <video
                        className="appear-animation-without-movement"
                        src={content.file}
                        width={350}
                        controls
                        autoPlay
                        onLoadedData={() => setLoading(false)}
                        preload="metadata"
                      />
                    )}
                  </div>
                  {loading && <GenerateSkeletonComponent count={1} height={202} width="100%" />}
                </Col>
                <Col xs={10} sm={10}>
                  <div className="content-info-bunlde">
                    <div className="infoTitle">{t('General information')}</div>
                    <InfoRow icon="tag" label={t('Name')}>
                      {editingName ? (
                        <Input
                          autoFocus
                          value={content.name}
                          onChange={e => onChangeName(e.target.value)}
                          onBlur={() => setEditingName(false)}
                          onPressEnter={() => setEditingName(false)}
                        />
                      ) : (
                        <div className="value">
                          {content.name}
                          {onChangeName && !disabled && (
                            <Tooltip title={t('Edit name')}>
                              <Icon
                                className="editIcon"
                                type="edit"
                                onClick={() => setEditingName(true)}
                              />
                            </Tooltip>
                          )}
                        </div>
                      )}
                    </InfoRow>
                    <InfoRow icon="fullscreen" label={t('Resolution')}>
                      <div className="value">
                        {content.width} x {content.height}
                      </div>
                    </InfoRow>
                    <InfoRow
                      icon={content.type === 'video' ? 'video-camera' : 'file-image'}
                      label={t('Type')}
                    >
                      <div className="value">{t(content.type === 'video' ? 'Video' : 'Image')}</div>
                    </InfoRow>
                    {content.type === 'video' && (
                      <InfoRow icon="clock-circle" label={t('Duration')}>
                        <div className="value">
                          {Math.floor(content.length / 1000)} {t('secs')}
                        </div>
                      </InfoRow>
                    )}
                  </div>
                </Col>
              </Row>
            )}
          </ModalContentHolder>
        </Modal>
      )}
    </>
  );
};

export default ModalContentComponent;
